import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ILayoutPart } from '../Shared/model/LayoutModel';
import { IResponseModel } from '../Shared/model/CommonModel';

export interface MandatoryFieldModel {
  listofValueId?: number;
  mandatory?: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class MandatoryfieldsettingService {
    private baseURL: string;
    constructor(private http: HttpClient) {
        this.baseURL = environment.apiBaseUrl;
    }

    GetMandatoyFields(): Observable<any> {
        return this.http.get(`${this.baseURL}/General/GetAllMandatoyFieldModules`, { observe: 'response' })
        .pipe(
            map(res => res.body),
            catchError(this.handleError)
        );
    }

    GetModuleFields(ModuleId): Observable<any> {
        return this.http.get(`${this.baseURL}/General/GetModuleFields?Id=${ModuleId}`, { observe: 'response' })
        .pipe(
            map(res => res.body),
            catchError(this.handleError)
        );
    }

    saveMandatoryFields(data): Observable<any> {
        return this.http.post(`${this.baseURL}/General/SaveMandatoryFields`, data)
        .pipe(
            map(res => {
            return res;
            }),
            catchError(this.handleError)
        );
    }
    
    GetModuleMandatoyFields(ModuleId): Observable<any> {
        return this.http.get(`${this.baseURL}/General/GetModuleMandatoyFields?ModuleId=${ModuleId}`, { observe: 'response' })
        .pipe(
            map(res => res.body),
            catchError(this.handleError)
        );
    }

    private handleError(error: HttpErrorResponse) {
        console.error('server error:', error);
        if (error.error instanceof Error) {
            const errMessage = error.error.message;
            return throwError(errMessage);
        }
        return throwError(error || 'Node.js server error');
    }
}